import {
  InsertData,
  InsertDataWithImage,
  
} from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import {
  CREACTE_APPLICATION , 
  GET_ALL_APPLICATION , 
  GET_APPLICATION_DATA ,
  DELETE_APPLICATION , 
  UPDATE_STATUE , 
  GET_COMMENTS , 
  SUBMIT_DOC ,
  CREACTE_CONSULTANT_APPLICATION
} from "../type";

//create new user
export const createApplicationAction = (data) => async (dispatch) => {
  try {
    const response = await InsertDataWithImage(`/api/create-application/`, data);
    dispatch({
      type: CREACTE_APPLICATION,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: CREACTE_APPLICATION,
      payload: e.response,
    });
  }
};
export const createConsultantApplicationAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/assign-consultant-application/`, data);
    dispatch({
      type: CREACTE_CONSULTANT_APPLICATION,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: CREACTE_CONSULTANT_APPLICATION,
      payload: e.response,
    });
  }
};
export const createDocApplicationAction = (data) => async (dispatch) => {
  try {
    const response = await InsertDataWithImage(`/api/submit-document/`, data);
    dispatch({
      type: SUBMIT_DOC,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: SUBMIT_DOC,
      payload: e.response,
    });
  }
};
export const createStatusApplicationAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/update-application-status/`, data);
    dispatch({
      type: UPDATE_STATUE,
      payload: response, 
      
    });
  } catch (e) {
    dispatch({
      type: UPDATE_STATUE,
      payload: e.response,
    });
  }
};
export const GetAllApplicationAction = (query) => async (dispatch) => {
  try {
    const response = await GetDataToken(`/api/get-all-applications/?${query}`);
    dispatch({
      type: GET_ALL_APPLICATION,
      payload: response,
    });
  }
   catch (e) {
    dispatch({
      type: GET_ALL_APPLICATION,
      payload: e.response,
    });
  }
};
export const GetCommentsApplicationAction = (id) => async (dispatch) => {
  try {
    const response = await GetDataToken(`/api/get-comments/${id}/`);
    dispatch({
      type: GET_COMMENTS,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: GET_COMMENTS,
      payload: e.response,
    });
  }
};
export const deleteApplicationAction = (URL,data) => async (dispatch) => {
  try {
    const response = await InsertData(URL,data);
    dispatch({
      type: DELETE_APPLICATION,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: DELETE_APPLICATION,
      payload: e.response,
    });
  }
};
export const GetDataApplicationAction = (id) => async (dispatch) => {
  try {
    const response = await GetDataToken(`/api/get-application-data/${id}/`);
    dispatch({
      type: GET_APPLICATION_DATA,
      payload: response,
    });
  } catch (e) {
    dispatch({
      type: GET_APPLICATION_DATA,
      payload: e.response,
    });
  }
};